function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  0%, 40%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import { Flex, Box, Colors } from '@tapresearch/ui/components';
import { keyframes } from '@chakra-ui/react';
var grow = keyframes(_templateObject());
function Dot(_param) {
    var animationDelay = _param.animationDelay, rest = _object_without_properties(_param, [
        "animationDelay"
    ]);
    return /*#__PURE__*/ React.createElement(Box, _object_spread({
        position: 'relative',
        borderRadius: 'full',
        animation: "1.2s ".concat(grow, " ease-in-out infinite ").concat(animationDelay)
    }, rest));
}
export function DotLoader(_param) {
    var _param_dotSize = _param.dotSize, dotSize = _param_dotSize === void 0 ? '10px' : _param_dotSize, _param_dotColor = _param.dotColor, dotColor = _param_dotColor === void 0 ? Colors.blue[200] : _param_dotColor, _param_animationDelayOffset = _param.animationDelayOffset, animationDelayOffset = _param_animationDelayOffset === void 0 ? 0.15 : _param_animationDelayOffset, rest = _object_without_properties(_param, [
        "dotSize",
        "dotColor",
        "animationDelayOffset"
    ]);
    return /*#__PURE__*/ React.createElement(Flex, _object_spread_props(_object_spread({
        alignItems: "center"
    }, rest), {
        "data-testid": "dot-loader"
    }), [
        0,
        1,
        2
    ].map(function(dotNumber) {
        var animationDelay = "".concat(dotNumber * animationDelayOffset, "s");
        return /*#__PURE__*/ React.createElement(Dot, {
            key: "dot-".concat(dotNumber),
            animationDelay: animationDelay,
            h: dotSize,
            w: dotSize,
            mr: "1",
            bgColor: dotColor
        });
    }));
}
